module.exports = __webpack_public_path__ + "img/live-stream-white.6847c660.svg";